module.exports = __webpack_public_path__ + "static/media/sponsered-img.442c0af9.png";